
























































































/** @format */
import { Vue, Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import moment from 'moment';
import { monthCardReportList, exportMonthCardReport } from '@/api/fixed-car-management';
import { TBsinessTypeMap } from '@/types/fixed-car-management/dictionaries.ts';
import Utils from '@root/utils/common';

@Component({
  name: 'FeeMonthlyShare',
  components: { ParkingLotSearch }
})
// @ts-ignore
export default class FeeMonthlyShare extends Mixins(TableMixin, TableWidthMixin) {
  private moment = moment;
  get defaultTime() {
    if (this.filterParam.startReportDate && this.filterParam.endReportDate) {
      return [
        this.moment(this.filterParam.startReportDate, 'YYYY-MM'),
        this.moment(this.filterParam.endReportDate, 'YYYY-MM')
      ];
    } else if (this.filterParam.startReportDate) {
      return [this.moment(this.filterParam.endReportDate, 'YYYY-MM')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  private tableLoading = false;
  private tableData: any[] = []; // 表数据
  // 业务类型数组
  private businessTypeList = Utils.toLabelVal(TBsinessTypeMap);
  private filterParam = {
    parkIds: [], // 车场id
    startReportDate: moment().format('YYYY-MM'), // 开始时间
    endReportDate: moment().format('YYYY-MM'), // 结束时间
    spaceCode: '', // 车位号
    cardType: '' // 业务类型
  };
  downloadFlag: boolean = true;
  created() {
    this.fetchTableData();
  }
  onPanelChange(value: { format: (arg0: string) => string }[], mode: any) {
    this.filterParam.startReportDate = value[0].format('YYYY-MM');
    this.filterParam.endReportDate = value[1].format('YYYY-MM');
  }

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '停车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'parkName' }
      },
      {
        title: '车位号',
        dataIndex: 'spaceCode',
        width: 120,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '业务类型',
        dataIndex: 'cardType',
        width: 120,
        customRender: (text: any) => TBsinessTypeMap[text]
      },
      {
        title: '期间',
        dataIndex: 'reportDay',
        width: 120,
        customRender: (text: any) => text
      },
      {
        title: '应收金额',
        dataIndex: 'receivableAmount',
        width: 130,
        customRender: (text: any) => text || '--'
      },
      {
        title: '预收分摊金额',
        dataIndex: 'advanceAmount',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '补缴金额',
        dataIndex: 'paybackAmount',
        width: 120,
        customRender: (text: any) => text || '--'
      },
      {
        title: '结转金额',
        dataIndex: 'carryoverAmount',
        width: 120,
        customRender: (text: any) => text || '--'
      },
      {
        title: '总实收金额',
        dataIndex: 'totalAmount',
        width: 120,
        customRender: (text: any) => text || '--'
      }
      // TODO 这俩列暂时不做
      // {
      //   title: '应收调整额',
      //   dataIndex: 'allNetReceiptsMoney',
      //   width: 120,
      //   customRender: (text: any) => text || '--',
      // },
      // {
      //   title: '操作',
      //   dataIndex: 'operation',
      //   fixed: 'right',
      //   width: 200,
      //   scopedSlots: { customRender: 'operation' },
      // },
    ];
  }
  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }
  /**
   * 点击清除按钮
   **/

  private onTableFilterClear({ defaultParkIdList }) {
    this.filterParam = {
      parkIds: defaultParkIdList, // 车场id
      startReportDate: moment().format('YYYY-MM'), // 开始时间
      endReportDate: moment().format('YYYY-MM'), // 结束时间
      spaceCode: '', // 车位号
      cardType: '' // 业务类型
    };
    this.fetchTableData();
  }
  /**
   * 请求列表
   */
  private async fetchTableData() {
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const {
        parkIds = [],
        startReportDate = '',
        endReportDate = '',
        spaceCode = '',
        cardType = ''
      } = this.filterParam;
      const { current } = this;
      const { data } = await monthCardReportList({
        parkIds: parkIds.join(','),
        startReportDate,
        endReportDate,
        spaceCode,
        cardType,
        currPage: current,
        pageSize: this.pageSize
      });
      const { datas = [], totalNum = 0, totalPage, currPage = 0, pageSize = 0, total } = data;
      this.total = Number(totalNum);
      if (total) {
        const { receivableAmount, advanceAmount, paybackAmount, carryoverAmount, totalAmount } = total;
        if (datas.length > 0) {
          datas.push({
            parkName: '合计',
            receivableAmount,
            advanceAmount,
            paybackAmount,
            carryoverAmount,
            totalAmount,
            isTotal: true
          });
        }
      }
      this.tableData = datas;
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  private async download() {
    try {
      const {
        parkIds = [], // 车场id
        startReportDate = '', // 开始时间
        endReportDate = '', // 结束时间
        spaceCode = '', // 车位号
        cardType = '' // 业务类型
      } = this.filterParam;
      const params = {
        parkIds: parkIds.join(','),
        startReportDate,
        endReportDate,
        spaceCode,
        cardType
      };
      if (this.downloadFlag) return;
      this.downloadFlag = true;
      await exportMonthCardReport({ ...params }, '收费月度分摊表');
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.downloadFlag = false;
    }
  }
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
}
